module.exports = __webpack_public_path__ + "media/components/assets/img/logo/australian-0719881ecb59cb6b8cc54099edaa9727.png";